import { showViewTokenState } from '@/atoms';
import { useDecryptToken } from '@/services/tokens';
import { Button, Group, Text } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { ModalLayout } from 'moh-ui';
import { useState } from 'react';
import { useRecoilState } from 'recoil-next';

export default function ViewTokenModal() {
   const [show, setShow] = useRecoilState(showViewTokenState);
   const [decryptedToken, setDecryptedToken] = useState('');
   const { mutate: decryptToken, isLoading } = useDecryptToken();

   const handleClose = () => {
      setShow(null);
      setDecryptedToken('');
   };

   const handleDecrypt = () => {
      if (show?.token) {
         decryptToken(show.token.encryptedApiKey, {
            onSuccess: (data) => {
               setDecryptedToken(data.data.decryptedToken);
            },
            onError: (error) => {
               showNotification({
                  title: 'Error',
                  message: error.message || 'Failed to decrypt token',
                  color: 'red',
               });
            },
         });
      }
   };

   return (
      <ModalLayout open={Boolean(show?.show)} onClose={handleClose} size="md">
         <h2 className="text-xl font-semibold">Token Details</h2>
         {show?.token && (
            <div className="space-y-4 mt-4">
               <p>
                  <strong>Owner:</strong> {show.token.owner}
               </p>
               <p>
                  <strong>Description:</strong> {show.token.description}
               </p>
               <p>
                  <strong>Origin:</strong> {show.token.origin}
               </p>
               <p>
                  <strong>Status:</strong> {show.token.isActive ? 'Active' : 'Inactive'}
               </p>
               <div>
                  <Button onClick={handleDecrypt} loading={isLoading} disabled={!!decryptedToken}>
                     {decryptedToken ? 'Decrypted' : 'Decrypt API Key'}
                  </Button>
                  {decryptedToken && (
                     <Text mt="sm" p="sm" style={{ border: '1px solid #ccc', borderRadius: '4px', background: '#f9f9f9' }}>
                        {decryptedToken}
                     </Text>
                  )}
               </div>
               <Group mt="md">
                  <Button variant="outline" onClick={handleClose}>
                     Close
                  </Button>
               </Group>
            </div>
         )}
      </ModalLayout>
   );
}
